export default __webpack_public_path__ + "static/media/picblue.a0e07e62.png";